function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useContext, useEffect, useMemo } from 'react';
import styles from './RecordCompareObjectRow.module.scss';
import { Column, Row } from '../Layout/RecordCompareLayout';
import SelectColumn from './RecordCompareSelectColumn';
import ReadOnlyColumn from './RecordCompareReadOnlyColumn';
import StaticTextColumn from './RecordCompareStaticTextColumn';
import { getRowId } from '../../util/recordCompareAria';
import PropertyTitle from './RecordComparePropertyTitle';
import CompareContext from './RecordCompareContext';
import Tooltip from '../../../Tips/Tooltip/Tooltip';
import PropertyAriaMessage from './RecordComparePropertyAriaMessage';
import ThemeContext from '../../../ThemeContext';
import RecordCompareStateContext from '../../RecordCompareStateContext';
import SelectCard from './CardView/RecordCompareSelectCard';
import ReadOnlyCard from './CardView/RecordCompareReadOnlyCard';
function getValue(data) {
  if (data === null || data === undefined) {
    return data;
  }
  if (Array.isArray(data)) {
    return data.sort().join('\n');
  }
  return "".concat(data);
}
function ObjectColumn(_ref) {
  var allEqual = _ref.allEqual,
    property = _ref.property,
    recordIndex = _ref.recordIndex;
  var _useContext = useContext(CompareContext),
    records = _useContext.records,
    isSelectable = _useContext.isSelectable,
    propertyPrefix = _useContext.propertyPrefix;
  var _useContext2 = useContext(RecordCompareStateContext),
    isMergeEnabled = _useContext2.isMergeEnabled,
    lastSelection = _useContext2.lastSelection,
    mergeSelections = _useContext2.mergeSelections,
    selections = _useContext2.selections,
    cardView = _useContext2.cardView;
  var record = records[recordIndex];
  var layout = record.layout;
  var selectionId = propertyPrefix + property;
  var checked = selections[selectionId] === recordIndex;
  var found = layout && layout.find(function (item) {
    return item.id === property;
  });
  var readOnlyRow = allEqual || !isSelectable || !isMergeEnabled;
  var readOnly = readOnlyRow || !found;
  var Component = !isMergeEnabled ? StaticTextColumn : readOnly ? cardView ? ReadOnlyCard : ReadOnlyColumn : cardView ? SelectCard : SelectColumn;
  useEffect(function () {
    // This "fixes" selection when a trigger field is selected. For example,
    // clicking "select all" for a book and then changing the contype to article,
    // this will select that article's newly available publisher field.
    if (checked && lastSelection !== recordIndex && !readOnlyRow && readOnly) {
      mergeSelections(_defineProperty({}, selectionId, lastSelection));
    }
  }, [mergeSelections, recordIndex, checked, readOnly, readOnlyRow, selectionId, lastSelection]);
  return /*#__PURE__*/React.createElement(Component, {
    property: property,
    recordIndex: recordIndex,
    checked: checked
  });
}
export default function ObjectRow(_ref2) {
  var property = _ref2.property;
  var _useContext3 = useContext(CompareContext),
    records = _useContext3.records,
    isSelectable = _useContext3.isSelectable;
  var _useContext4 = useContext(RecordCompareStateContext),
    isMergeEnabled = _useContext4.isMergeEnabled,
    cardView = _useContext4.cardView;
  var allEqual = useMemo(function () {
    var data = records[0].data;
    var firstValue = getValue(data[property]);
    return records.reduce(function (allEqual, record) {
      return allEqual && getValue(record.data[property]) === firstValue;
    }, true);
  }, [property, records]);
  var selectable = isSelectable || !isMergeEnabled;
  var theme = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PropertyAriaMessage, {
    property: property
  }), /*#__PURE__*/React.createElement(Tooltip, {
    key: "".concat(property, "-").concat(selectable),
    i18nKey: "@dm/components.record-compare.tooltips.field-not-selectable",
    neverShow: selectable
  }, function (_ref3) {
    var ref = _ref3.ref,
      describedby = _ref3.describedby,
      events = _ref3.events;
    return /*#__PURE__*/React.createElement("div", Object.assign({
      "aria-describedby": describedby,
      ref: ref
    }, events, {
      className: allEqual ? "".concat(styles[theme]) : ""
    }), /*#__PURE__*/React.createElement(Row, {
      className: !selectable ? styles.unselectable : ''
    }, !cardView ? /*#__PURE__*/React.createElement(Column, {
      id: getRowId(property),
      tabbed: true
    }, /*#__PURE__*/React.createElement(PropertyTitle, {
      property: property
    })) : null, records.map(function (record, recordIndex) {
      return /*#__PURE__*/React.createElement(ObjectColumn, {
        allEqual: allEqual,
        key: "".concat(property, "-").concat(record.recordId),
        property: property,
        recordIndex: recordIndex
      });
    })));
  }));
}